import { call, put } from 'redux-saga/effects';

import { fetchEntities } from 'services';

import {
  REQUEST_RELATED_ENTITIES_SUCCESS,
  REQUEST_RELATED_ENTITIES_ERROR,
} from './relatedEntitiesActions';

export function* requestRelatedEntitiesSaga({ payload }) {
  try {
    const response = yield call(fetchEntities, { filter: { issuerIds: payload.ids } });
    yield put({ type: REQUEST_RELATED_ENTITIES_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: REQUEST_RELATED_ENTITIES_ERROR, payload: response });
  }
}
